module.exports = __webpack_public_path__ + "5093829a51f4f7c9e511fe26df17e70d.svg";